import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui'
import { api } from '@/api/client'

interface PaymentButtonProps {
  shortCode: string
}

export default function PaymentButton({ shortCode }: PaymentButtonProps) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handlePayment = async () => {
    setIsLoading(true)
    setError(null)

    try {
      const data = await api.initiatePayment(shortCode)

      // Redirect to Transbank payment page
      // Create a form and submit it (Transbank requires POST)
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = data.url

      const tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'token_ws'
      tokenInput.value = data.token

      form.appendChild(tokenInput)
      document.body.appendChild(form)
      form.submit()
    } catch (err) {
      setError(err instanceof Error ? err.message : t('payment.errorOccurred'))
      setIsLoading(false)
    }
  }

  return (
    <div className="space-y-4">
      {error && (
        <div className="p-4 rounded-lg bg-red-50 border border-red-200">
          <p className="text-sm text-red-700">{error}</p>
        </div>
      )}

      <Button
        onClick={handlePayment}
        isLoading={isLoading}
        variant="copper"
        size="lg"
        className="w-full"
      >
        {isLoading ? t('payment.redirecting') : t('payment.payNow')}
      </Button>

      <p className="text-xs text-center text-neutral-500">
        {t('payment.redirectNotice')}
      </p>
    </div>
  )
}
